export enum ActionTypes {
  GetEmailValidation = 'getEmailValidation',
  GetEmailValidationSuccess = 'getEmailValidation.success',
  GetEmailValidationFailure = 'getEmailValidation.failure',
}
